// Settings > Pricing > Service Add-ons: the migration 104 options under one add-on row.
// Flat or percent (a percent is taken of the stop's snow + salt), whether the
// add-on shows on the rates page and signup form, whether the on-call premium
// applies to it, and an optional detail the customer card asks for.

import React from 'react';

export const DETAIL_LABEL_MAX = 40;

// The options as the card holds them, from a GET /api/service-addons/all row.
export const addonFeesFromRow = (row) => ({
  pricingType: row && row.pricing_type === 'percent' ? 'percent' : 'flat',
  percent: row && row.percent !== null && row.percent !== undefined && row.percent !== ''
    ? String(parseFloat(row.percent))
    : '',
  isPublic: !row || row.is_public !== false,
  premiumApplies: !row || row.premium_applies !== false,
  detailLabel: (row && row.detail_label) || '',
});

export const defaultAddonFees = () => addonFeesFromRow(null);

// The POST / PUT body fields. A percent is sent only on a percent add-on (the
// server refuses one on a flat add-on); a blank percent is left for the server
// to answer "A percent add-on needs a percent".
export const addonFeeBody = (fees) => {
  const f = fees || defaultAddonFees();
  const body = {
    pricingType: f.pricingType,
    isPublic: f.isPublic,
    premiumApplies: f.premiumApplies,
    detailLabel: f.detailLabel.trim() === '' ? null : f.detailLabel.trim(),
  };
  if (f.pricingType === 'percent' && f.percent !== '') body.percent = Number(f.percent);
  return body;
};

const AddonFeeOptions = ({ fees, onChange, idPrefix }) => {
  const f = fees || defaultAddonFees();
  const id = (name) => `${idPrefix}-${name}`;
  return (
    <div className="addon-fee-options">
      <label className="addon-fee-option" htmlFor={id('type')}>
        Charge
        <select
          id={id('type')}
          className="form-input addon-fee-type"
          value={f.pricingType}
          onChange={(e) => onChange({ pricingType: e.target.value })}
        >
          <option value="flat">Flat $</option>
          <option value="percent">Percent</option>
        </select>
      </label>
      {f.pricingType === 'percent' && (
        <span className="addon-fee-option">
          <input
            id={id('percent')}
            type="number"
            className="form-input addon-price-input addon-fee-percent"
            aria-label="Percent"
            value={f.percent}
            onChange={(e) => onChange({ percent: e.target.value })}
            step="0.01"
            min="0.01"
            max="100"
            placeholder="10"
          />
          <span className="addon-fee-hint">% of snow + salt</span>
        </span>
      )}
      <label className="addon-fee-option">
        <input
          type="checkbox"
          checked={f.isPublic}
          onChange={(e) => onChange({ isPublic: e.target.checked })}
        />
        Show on rates page and signup
      </label>
      <label className="addon-fee-option">
        <input
          type="checkbox"
          checked={f.premiumApplies}
          onChange={(e) => onChange({ premiumApplies: e.target.checked })}
        />
        On-call premium applies
      </label>
      <label className="addon-fee-option" htmlFor={id('detail')}>
        Ask for a detail
        <input
          id={id('detail')}
          type="text"
          className="form-input addon-fee-detail"
          value={f.detailLabel}
          onChange={(e) => onChange({ detailLabel: e.target.value })}
          maxLength={DETAIL_LABEL_MAX}
          placeholder="e.g. Done by (optional)"
        />
      </label>
    </div>
  );
};

export default AddonFeeOptions;
